<template>
  <v-btn
    color="primary"
    class="mr-3"
    :loading="loading"
    :disabled="loading"
    @click="reindex"
  >
    Re-index
  </v-btn>
</template>

<script>
export default {
  props: {
    paymentId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    reindex() {
      this.loading = true;

      this.$http
        .post(`/api/v1/payments/${this.paymentId}/reindex`)
        .then((response) => {
          console.log("Reindex successful:", response);
          if (response.success) {
              Notify.success(response.message);
          }
        })
        .catch((error) => {
          console.error("Error while reindexing:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
